export default __webpack_public_path__ + "static/media/BG-Yellow.9ccebb0f.jpg";